window.addEventListener('DOMContentLoaded', toggleHandler);

function toggleHandler() {
  const toggle = document.getElementById('menu-toggle');
  const menu = document.getElementById('primary-menu');
  const content = document.getElementById('primary-content');

  if (toggle && menu && content) {
    toggle.addEventListener('click', () => {
      const status = toggle.getAttribute('aria-expanded') === 'true';

      toggle.setAttribute('aria-expanded', !status);
      menu.setAttribute('aria-expanded', !status);
      content.setAttribute('data-menu', !status);
    });
  }
}
